module.exports = __webpack_public_path__ + "img/30.b23c855d.png";